<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			width="600px"
			center
			:append-to-body='true'
			@close="closePreview"
			:visible.sync="previeWin">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					预览
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData1">
				<div id="" v-if="type==1">
					<img class="preview" :src="introduce" v-if="bsid == 'img'">
					<iframe :src="introduce" v-if="bsid == 'pdf'"></iframe>
				</div>
				<div id="" v-else>
					<img class="preview" :src="receipt" v-if="bsid1 == 'img'">
					<iframe :src="receipt" v-if="bsid1 == 'pdf'"></iframe>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="closePreview">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dyjy } from '@/axios'
	let that;
	export default{
		data(){
			return{
				introduce:"",
				receipt:"",
				type:"",
				bsid:"",
				bsid1:""
			}
		},
		props:{
			previeWin:{
				type:Boolean,
				default:false
			}
		},
		created() {
			that = this;
		},
		methods:{
			closePreview(){
				that.introduce = "";
				that.receipt = "";
				that.bsid = "";
				that.type = "";
				that.bsid1 = "";
				that.$emit("closePreview")
			},
			// 绑定数据
			bindData(uid,type){
				that.type = type
				dyjy.introduceDetail({
					uid:uid
				}).then(res => {
					if(res.code == 200){
						that.introduce = res.detail.introduce;
						that.receipt = res.detail.receipt
						if(type == 1){
							if(that.introduce){
								if(that.introduce.search('pdf')!=-1){
									that.bsid = 'pdf'
								}else{
									that.bsid = 'img'
								}
							}
						}else{
							if(that.receipt){
								if(that.receipt.search('pdf')!=-1){
									that.bsid1 = 'pdf'
								}else{
									that.bsid1 = 'img'
								}
							}
						}
					}else{
						Message.error(res.msg)
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.preview{
		width: 560px;
	}
	iframe{
		width: 500px;
		height: 450px;
		overflow-y: scroll;
		background-color: none;
		border: none;
	}
</style>
